import React from 'react';

import useTheme from '@hero/branding/theme';
import { IconComponentProps } from '@hero/ui-kit/types';

const CopyIcon: React.FC<IconComponentProps> = ({
    type = 'utility',
    size = 'regular',
    disabled = false,
    styles,
    color = 'currentColor',
    ...rest
}) => {
    const { sizing } = useTheme();
    const sizePx = sizing.widths.icon[size];

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            width={sizePx}
            height={sizePx}
            style={styles}
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...rest}
        >
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
    );
};

export default CopyIcon;
